import type { Analytics, Context, Plugin } from "@segment/analytics-next";

export function orgEventPropertiesPlugin(): Plugin {
    let loadedAnalytics: Analytics;

    function withIdentifiedOrg(ctx: Context): Context {
        const identifiedTraits = loadedAnalytics.user().traits();
        ctx.updateEvent("properties.org", identifiedTraits?.org);
        ctx.updateEvent("properties.orgId", identifiedTraits?.orgId);
        return ctx;
    }

    return {
        name: "Org Event Properties",
        type: "enrichment",
        version: "1.0.0",
        isLoaded: () => true,
        load: async (_ctx, analytics) => {
            loadedAnalytics = analytics;
        },
        track: withIdentifiedOrg,
        page: withIdentifiedOrg,
    };
}
